document.addEventListener('DOMContentLoaded', () => {
  const giftInput = document.getElementById('giftcertificateid');
  if (!giftInput) return;

 let alreadyFocused = false;

const observer = new MutationObserver(() => {
  if (giftInput.classList.contains('is-invalid') && !alreadyFocused) {
    giftInput.setAttribute('aria-invalid', 'true');
    giftInput.setAttribute('aria-label', 'Please enter a valid Gift Certificate.');
    giftInput.focus();
    alreadyFocused = true;
  } else if (!giftInput.classList.contains('is-invalid')) {
    alreadyFocused = false;
  }
});

  observer.observe(giftInput, {
    attributes: true,
    attributeFilter: ['class']
  });
});
